{
  "version": 1,
  "asset_id": "09706766-f2c1-4578-8a32-1e09d0e256cb",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/09706766-f2c1-4578-8a32-1e09d0e256cb/svc-google-business-profile-1200.avif",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/09706766-f2c1-4578-8a32-1e09d0e256cb/svc-google-business-profile-1200.avif",
  "original_filename": "svc-google-business-profile-1200.avif",
  "size": 7605,
  "content_type": "image/avif",
  "created_at": "2026-07-25T02:26:50Z"
}
